import React from 'react';
import { useMutation } from '@apollo/react-hooks';

import plusCircled from '../../../../../images/plus-circled.svg';
import rewardCardPackFallbackCover from '../../../../../images/reward-card-pack-fallback-cover.svg';
import rewardPackDelete from '../../../../../images/reward-card-delete.svg';
import { navigate } from '@reach/router';
import styles from './RewardCardsPackList.module.scss';
import { DELETE_REWARD_CARD_PACK } from '../../../services/graphql';

const RewardPacksList = ({ rewardPacks, onPackDeleted }) => {

    const [deleteRewardCardsPack] = useMutation(DELETE_REWARD_CARD_PACK, {
        onCompleted: () => {
            onPackDeleted();
        },
    })

    const onDeletePack = (rewardPack) => {
        const goAhead = window.confirm(
            `Are you sure you want to delete ${rewardPack.name}?`
        );
        if (goAhead) {
            deleteRewardCardsPack({
                variables: {
                    rewardCardPackId: rewardPack.id,
                },
            });
        }
    };

    return (
        <div className={styles.rewardCardsContainer}>
            <div
                target='blank'
                className={`${styles.rewardPackWrapper} ${styles.emptyRewardPack}`}
                rel='noopener noreferrer'
                onClick={() => navigate(`/rewardPacks/pack/new`)}
            >
                <img width='48' src={plusCircled} alt='plus-circle-svg' />
            </div>
            {rewardPacks.map((rewardPack) => (
                <div
                    key={rewardPack.id}
                    className={styles.rewardPackWrapper}
                    onClick={() => navigate(`/rewardPacks/pack/${rewardPack.id}`, {
                        state: rewardPack
                    })}>

                    <img
                        className={styles.deletePack}
                        src={rewardPackDelete}
                        alt='Delete reward cards pack'
                        onClick={(e) => {
                            e.stopPropagation()
                            onDeletePack(rewardPack)
                        }
                        }
                    />

                    <div className={styles.rewardPackButtonsContainer}></div>
                    {rewardPack?.previewImageUrl ? (
                        <img
                            className={styles.rewardPackCoverImage}
                            src={rewardPack.previewImageUrl}
                            alt='Reward pack cover image'
                        />
                    ) :
                        <img
                            className={styles.rewardPackCoverImage}
                            src={rewardCardPackFallbackCover}
                            alt='Reward pack cover fallback image'
                        />}

                    <p className={`${styles.rewardPackName} ${styles.MessageElipsis} u-m-top-1`}>{rewardPack.name}</p>
                </div>
            ))}
        </div>
    )
};


export default RewardPacksList;